import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { map, switchMap, catchError } from 'rxjs/operators';
import {
  FETCH_INTEGRATIONS,
  FETCH_INTEGRATIONS_SUCCESS
} from '../../constants';

const fetchIntegrations = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_INTEGRATIONS),
    switchMap((action) =>
    {
     return ajax({
        url: `${state$.value.auth.audienceBuilderServer}/integrations?clientId=${action.clientId}`,
        headers: {
          Authorization: state$.value.auth.token,
          'Content-Type': 'application/json',
        },
        responseType: 'json',
        crossDomain: true,
        method: 'GET',
      }).pipe(
        map(response => {
          return {
            type: FETCH_INTEGRATIONS_SUCCESS,
            data: response.response
          };
        }),
        catchError(error =>{
          console.log(error)
        }

        )
      )
        }
    )
  );

export default fetchIntegrations;
